import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

interface TrendBadgeProps {
  value: number;
  isPositive: boolean;
  showIcon?: boolean;
  size?: "sm" | "md" | "lg";
}

export function TrendBadge({ 
  value, 
  isPositive, 
  showIcon = false,
  size = "md" 
}: TrendBadgeProps) {
  const isNeutral = value === 0;
  
  const Icon = isNeutral ? Minus : isPositive ? TrendingUp : TrendingDown;
  
  const sizeClasses = {
    sm: "text-[10px] px-1.5 py-0.5",
    md: "text-xs px-2 py-0.5",
    lg: "text-sm px-2.5 py-1",
  };
  
  const iconSizes = {
    sm: "h-2.5 w-2.5",
    md: "h-3 w-3",
    lg: "h-3.5 w-3.5",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full font-semibold transition-colors",
        sizeClasses[size],
        isPositive && "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
        !isPositive && !isNeutral && "bg-rose-500/10 text-rose-600 dark:text-rose-400",
        isNeutral && "bg-muted text-muted-foreground"
      )}
    >
      {showIcon && (
        <Icon className={cn(iconSizes[size])} />
      )}
      {isPositive ? "+" : ""}
      {value.toFixed(1)}%
    </span>
  );
}
